import { css } from '@vpbdevops/common';
export default css `
  :host {
    display: inline-block;
  }

  .button {
    font-family: var(--vpb-asset-font-avenir-next-world-demi-name, 'Avenir Next');
    font-weight: var(--vpb-asset-font-avenir-next-world-demi-font-weight, 600);
    font-size: var(--vpb-size-font-text-sm-demi, 16px);
    line-height: var(--vpb-size-line-height-text-sm-demi, 24px);
    letter-spacing: var(--vpb-size-letter-spacing-text-sm-demi, 0.3px);
    display: inline-flex;
    align-items: stretch;
    justify-content: center;
    cursor: pointer;
    padding: var(--vpb-spacing-sm, 16px) var(--vpb-spacing-md, 24px);
    border: 1px solid transparent;
    outline: none;
    text-decoration: none;
  }

  .button .label {
    display: inline-flex;
  }

  .button.-filled {
    color: var(--vpb-color-text-on-primary, #fff);
    background: var(--vpb-color-background-primary, #00376e);
    border-color: var(--vpb-color-border-primary, #00376e);
  }

  .button.-filled:hover,
  .button.-filled.-focused {
    background: var(--vpb-color-background-primary-hover, #00264d);
  }

  .button.-filled.-focused {
    box-shadow:
      0 0 0 2px #fff,
      0 0 0 4px var(--vpb-color-border-neutral, #e4e7eb);
  }

  .button.-outlined {
    background: var(--vpb-color-background-neutral, #fff);
    color: var(--vpb-color-text-primary, #00376e);
    border-color: var(--vpb-color-border-neutral, #e4e7eb);
  }

  .button.-outlined:hover,
  .button.-outlined.-focused {
    border-color: var(--vpb-color-border-primary-hover, #00264d);
  }

  .button.-outlined.-focused {
    box-shadow: 0 0 0 2px var(--vpb-color-border-neutral, #e4e7eb);
  }

  .button.-ghost {
    background: var(--vpb-color-background-neutral, #fff);
    color: var(--vpb-color-text-primary, #00376e);
    border-color: var(--vpb-color-border-primary-hover, #00264d);
  }

  .button.-ghost:hover {
    box-shadow: 0 0 0 1px var(--vpb-color-border-primary-hover, #00264d);
  }

  .button.-ghost.-focused {
    box-shadow:
      0 0 0 1px var(--vpb-color-border-primary-hover, #00264d),
      0 0 0 3px var(--vpb-color-border-neutral, #e4e7eb);
  }

  .button.-link {
    background: transparent;
    color: var(--vpb-color-text-primary, #00376e);
    padding: 0;
    position: relative;
    text-decoration: none;
  }

  .button.-link::after {
    content: '';
    display: block;
    height: 2px;
    width: 100%;
    background-image: linear-gradient(90deg, currentColor, currentColor);
    background-size: min(65%, 48px) 100%;
    transition: all 125ms cubic-bezier(0.3, 0.42, 0.31, 1);
    background-repeat: no-repeat;
    background-position: 0;
    position: absolute;
    top: 100%;
  }

  .button.-link:not(.-disabled):active::after,
  .button.-link:not(.-disabled).-active::after,
  .button.-link:not(.-disabled):hover::after,
  .button.-link:not(.-disabled).-focused::after {
    background-size: 100% 100%;
  }

  .button.-link.-focused {
    box-shadow: 0 0 0 2px var(--vpb-color-border-neutral, #e4e7eb);
  }

  .button.-small {
    font-size: 0.875rem;
  }

  .button:not(.-link).-small {
    padding: var(--vpb-spacing-3xs, 4px) var(--vpb-spacing-xs, 12px);
  }

  .button:not(.-link).-medium {
    padding: var(--vpb-spacing-2xs, 8px) var(--vpb-spacing-sm, 16px);
  }

  .button.-disabled {
    cursor: not-allowed;
  }

  .button.-filled.-disabled,
  .button.-outlined.-disabled,
  .button.-ghost.-disabled {
    color: var(--vpb-color-text-disabled, #d0d6db);
    border-color: var(--vpb-color-border-disabled, #e4e7eb);
    background: var(--vpb-color-background-disabled, #f8f9fa);
    box-shadow: none;
  }

  .button.-link.-disabled {
    color: var(--vpb-color-text-disabled, #d0d6db);
    text-decoration-color: var(--vpb-color-border-disabled, #e4e7eb);
  }

  .button .prefix,
  .button .suffix {
    flex: 0 0 auto;
    align-items: center;
    pointer-events: none;
    display: none;
  }

  .button.-prefixed .label {
    margin-left: var(--vpb-spacing-2xs, 8px);
  }

  .button.-suffixed .label {
    margin-right: var(--vpb-spacing-2xs, 8px);
  }

  .button.-prefixed .prefix,
  .button.-suffixed .suffix {
    display: flex;
  }
`;
//# sourceMappingURL=button.scss.js.map